import React, {useEffect} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {toast, ToastContainer} from 'react-toastify';
import {CloseButton, Fade} from '../components/common/Toast';
import DashboardLayout from './DashboardLayout';
import loadable from '@loadable/component';
import RegisterPage from './../components/register/RegisterPage';
import ProfileSettingsLayout from './ProfileSettingsLayout';
const Landing = loadable(() => import('../components/landing/Landing'));

const Layout = () => {
  useEffect(() => {
    Landing.preload();
  }, []);

  return (
    <Router fallback={<span />}>
      <Switch>
        <Route path="/landing" exact component={Landing} />
        <Route path="/dashboard" component={DashboardLayout} />
        <Route path="/register" component={RegisterPage} />
        <Route path="/settings" component={ProfileSettingsLayout} />
        <Route component={Landing} />
      </Switch>
      <ToastContainer
        transition={Fade}        
        closeButton={false}
        position={toast.POSITION.TOP_RIGHT}
      />
    </Router>
  );
};

export default Layout;
